<template>
    <section class="">
      <WelcomeModal :show="$route.query.welcome === 'true'" @skip="handleSkip" />
      <div class="px-8" v-if="hasAcess">

        <div v-if="showNewUserSetupCard" class="setup-card-wrap">
          <section class="setup-checklist-card" aria-labelledby="new-user-setup-title">
            <header class="setup-checklist-header">
              <div>
                <span class="setup-kicker">{{ $t('new_user_setup') }}</span>
                <h5 id="new-user-setup-title">{{ $t('new_user_setup_title') }}</h5>
                <p>{{ $t('new_user_setup_description') }}</p>
              </div>
              <button
                type="button"
                class="btn btn-light rounded-circle setup-dismiss-btn"
                :disabled="dismissingSetupChecklist"
                :title="$t('close')"
                :aria-label="$t('close')"
                @click="dismissSetupChecklist"
              >
                <span v-if="dismissingSetupChecklist" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                <AppIcon name="bi-x-lg" v-else class="bi bi-x-lg" aria-hidden="true" />
              </button>
            </header>

            <div class="setup-steps">
              <button
                v-for="step in setupSteps"
                :key="step.key"
                type="button"
                class="setup-step"
                @click="goToSetupStep(step)"
              >
                <span class="setup-step-icon" aria-hidden="true">
                  <AppIcon :name="step.icon" :class="step.icon" />
                </span>
                <span class="setup-step-content">
                  <strong>{{ step.title }}</strong>
                  <small>{{ step.description }}</small>
                </span>
                <AppIcon name="bi-arrow-right" class="bi bi-arrow-right setup-step-arrow" aria-hidden="true" />
              </button>
            </div>
          </section>
        </div>

        <div class="row">

          <FinancialInsightsVue />

        </div>
      </div>
      <div v-else class="px-8" style="margin:auto;text-align:center">
        <img src="/images/401.png" alt="" style="width:400px">
        <p>{{$t('unauthorized')}}</p>
      </div>

    </section>
</template>

<script>
import moment from 'moment'
import helper from '../helper'
// import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import FinancialInsightsVue from '../components/FinancialInsights.vue'
import WelcomeModal from '../components/WelcomeModal.vue'

export default {
  name: 'Dashboard',
  components : {
    // DatePicker,
    FinancialInsightsVue,
    WelcomeModal
  },
  data(){
    return {
      missing : [],
      range : [],
      start :  moment().subtract(3,'month').format('YYYY-MM-DD'),
      end : moment().format('YYYY-MM-DD'),
      duration : 'last_3months',
      shortcuts: [
          {
            text: "Aujourd'hui",
            onClick() {
              return [moment().toDate(),moment().toDate()];
            },
          },
          {
            text: 'Hier',
            onClick() {
              return [moment().subtract(1,"days").toDate(),moment().toDate()];
            },
          },
          {
            text: 'Mois dernier',
            onClick() {
              return [moment().subtract(30,"days").toDate(),moment().toDate()];
            },
          }
      ],
      loading : false,
      total : 0,
      total_given : 0,
      rest : 0,
      profit : 0,
      outOfStock : [],
      topProducts : [],
      start_date : moment().subtract(30,'days').format('YYYY-MM-DD'),
      end_date : moment().format('YYYY-MM-DD'),
      logs : [],
      hasAcess : true,
      showSubscriptionModalisOpen : false,
      showSubscriptionModal : null,
      dismissingSetupChecklist: false
    }
  },
  async mounted(){
    window.mixpanel.track("dashboard");

    if(this.business?.id && helper.checkAccess('view_dashboard') == -1){
      this.hasAcess = false
      // check next enabled access
      const enabledModules = (this.$store.getters.MODULES || []).filter(m => m.enabled);
      if (enabledModules.length > 0) {
        for(let i = 0 ; i < enabledModules.length; i++){
          if(enabledModules[i].items && enabledModules[i].items.length > 0){
            // check if the first item is enabled
            const firstEnabledItem = enabledModules[i].items.find(item => item.enabled);
            if(firstEnabledItem && firstEnabledItem.link){
              this.$router.push({ path: firstEnabledItem.link });
              return;
            }
          }
        }
      }
     
    }else if(this.business?.id  && helper.checkAccess('view_dashboard') == -2){
      return this.$router.push({path : '/subscribe'})
    }

  },
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    user(){ return this.$store.getters.USER},
    freeTrials(){ return moment(this.$store.getters.BUSINESS.trial_end_at).diff(moment(), "days" )},
    businessStatus(){ return this.$store.getters.BUSINESS.status},
    isNewAccount() {
      if (!this.business?.created_at) return false
      const createdAt = moment(this.business.created_at)
      if (!createdAt.isValid()) return false
      const accountAgeInDays = moment().diff(createdAt, 'days')
      return accountAgeInDays >= 0 && accountAgeInDays <= 30
    },
    newAccountSetupDismissed() {
      return Boolean(this.business?.metadata?.new_account_setup?.dismissed_at)
    },
    showNewUserSetupCard() {
      return this.isNewAccount && !this.newAccountSetupDismissed && this.setupSteps.length > 0
    },
    requiredBusinessInfoFields() {
      return [
        { key: 'name', labelKey: 'business_name' },
        { key: 'phone', labelKey: 'business_phone' },
        { key: 'email', labelKey: 'business_email' },
        { key: 'address', labelKey: 'business_address' },
        { key: 'currency', labelKey: 'currency' },
        { key: 'vat', labelKey: 'vat' },
        { key: 'billing_info', labelKey: 'billing_info' },
        { key: 'payment_term', labelKey: 'payment_term' }
      ]
    },
    missingBusinessInfo() {
      return this.requiredBusinessInfoFields
        .filter(field => this.isBusinessFieldMissing(field.key))
        .map(field => this.$t(field.labelKey))
    },
    setupSteps() {
      const steps = []

      if (this.missingBusinessInfo.length) {
        const visibleFields = this.missingBusinessInfo.slice(0, 3).join(', ')
        steps.push({
          key: 'business_info',
          title: this.$t('missing_business_information'),
          description: this.$t('missing_business_information_description', {
            fields: `${visibleFields}${this.missingBusinessInfo.length > 3 ? '…' : ''}`
          }),
          icon: 'bi bi-building-exclamation',
          path: '/settings/general'
        })
      }

      steps.push({
        key: 'invoice_template',
        title: this.$t('pick_invoice_model'),
        description: this.$t('pick_invoice_model_description'),
        icon: 'bi bi-file-earmark-richtext',
        path: '/settings/modules',
        query: { open: 'sales', section: 'template' }
      })

      return steps
    }
  },
  methods: {
    handleSkip() {
      const query = { ...this.$route.query };
      delete query.welcome;
      // Older onboarding links may still contain this flag. Remove it without
      // reloading now that onboarding hydrates the owner role before navigation.
      delete query.setup;
      this.$router.replace({ query }).catch(() => {});
    },
    isBusinessFieldMissing(fieldKey) {
      const value = this.business?.[fieldKey]
      if (value === 0) return false
      if (value === null || value === undefined) return true
      if (typeof value === 'string') return value.trim().length === 0
      return false
    },
    async dismissSetupChecklist() {
      if (this.dismissingSetupChecklist) return

      this.dismissingSetupChecklist = true
      try {
        const response = await helper.customPost(
          `${process.env.VUE_APP_API}/businesses/dismiss-new-account-setup`,
          {}
        )
        const business = {
          ...this.business,
          metadata: {
            ...(this.business.metadata || {}),
            new_account_setup: response.data.new_account_setup
          }
        }
        this.$store.commit('SET_BUSINESS', business)

        const query = { ...this.$route.query }
        delete query.setup
        this.$router.replace({ query }).catch(() => {})
      } catch {
        // The request helper already reports the API error; keep the card visible.
      } finally {
        this.dismissingSetupChecklist = false
      }
    },
    goToSetupStep(step) {
      this.$router.push({ path: step.path, query: step.query || {} })
    }
  }
}
</script>

<style scoped>
.setup-card-wrap {
  margin: 22px 0 18px;
}

.setup-checklist-card {
  background: #fff;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: .25rem;
  padding: 18px;
  width: 100%;
}

.setup-checklist-header {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 16px;
}

.setup-kicker {
  color: #2563eb;
  display: block;
  font-size: 0.68rem;
  font-weight: 800;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.setup-checklist-header h5 {
  color: #0f172a;
  font-weight: 850;
  margin: 0 0 5px;
}

.setup-checklist-header p {
  color: #64748b;
  font-size: 0.9rem;
  margin: 0;
}

.setup-dismiss-btn {
  align-items: center;
  border: 1px solid #e2e8f0;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  padding: 0;
  width: 34px;
}

.setup-steps {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.setup-step {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #0f172a;
  cursor: pointer;
  display: flex;
  gap: 12px;
  min-height: 72px;
  padding: 12px;
  text-align: left;
  transition: border-color .2s ease, transform .2s ease;
  width: 100%;
}

.setup-step:hover {
  border-color: #93c5fd;
  transform: translateY(-1px);
}

.setup-step-icon {
  align-items: center;
  background: #2563eb;
  border-radius: 8px;
  color: #fff;
  display: inline-flex;
  flex: 0 0 34px;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.setup-step-content {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.setup-step-content strong {
  font-size: 0.9rem;
  font-weight: 850;
}

.setup-step-content small {
  color: #64748b;
  font-size: 0.78rem;
  line-height: 1.35;
}

.setup-step-arrow {
  color: #94a3b8;
  margin-left: auto;
}

@media (max-width: 576px) {
  .setup-card-wrap {
    margin-top: 14px;
  }

  .setup-checklist-card {
    padding: 14px;
  }

  .setup-steps {
    grid-template-columns: 1fr;
  }
}
</style>
